import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import CommonTooltip from '../../../../../component/common/CommonTooltip';
const PlIntegration = () => {
    return (
        <div className='row px-10 mb-20'>
            <div className="col-md-12 text-center">
                <h2 className="section-title fs-3x text-grad-3 mb-20">Integrations</h2>
            </div>
            <div className='row border br-20 mb-10'>
                <div className='col-md-7'>
                    <div className='card card  h-100'>
                        <div className='card-body'>
                            <div className="title-wrap">
                                <h3 className="title fs-1 my-4 text-gray-800">
                                    Chat
                                </h3>
                            </div>
                            <ul className="list-check text-gray-700 ps-5">
                                <li className='d-flex fs-3'>
                                    <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                    TruChat Widget
                                </li>
                                <li className='d-flex fs-3'>
                                    <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                    WhatsApp
                                </li>
                                <li className='d-flex fs-3'>
                                    <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                    Telegram 
                                </li>
                                <li className='d-flex fs-3'>
                                    <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                    Facebook Messenger
                                </li>
                            </ul>
                            <div className="title-wrap mt-10">
                                <h3 className="title fs-1 my-4 text-gray-800">
                                    Voice
                                </h3>
                            </div>
                            <ul className="list-check text-gray-700 ps-5">
                                <li className='d-flex fs-3'>
                                    <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                    Speech-to-text and Text-to-speech APIs
                                </li>
                            </ul>
                            <div className="title-wrap mt-10">
                                <h3 className="title fs-1 my-4 text-gray-800">
                                    Telephony
                                </h3>
                            </div>
                            <ul className="list-check text-gray-700 ps-5">
                                <li className='d-flex fs-3'>
                                    <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                    WebRTC
                                </li>
                                <li className='d-flex fs-3'>
                                    <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                    SIP Trunking
                                </li>
                            </ul>
                            <div className="title-wrap mt-10">
                                <h3 className="title fs-1 my-4 text-gray-800">
                                    Reporting
                                </h3>
                            </div>
                            <ul className="list-check text-gray-700 ps-5">
                                <li className='d-flex fs-3'>
                                    <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                    Call details report
                                </li>
                                <li className='d-flex fs-3'>
                                    <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                    Call transcripts
                                </li>
                            </ul>
                            <p className="text my-3 pe-5 fs-3 text-gray-700 mt-10">
                                For custom channel integrations, write to &nbsp;
                                <a href="mailto:techsupport@truvoice.ai" className="text-primary">
                                    techsupport@truvoice.ai
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
                <div className='col-md-5 m-auto'>
                    <div className='col-md-3 channel-box me-4'>
                        <img 
                            src="/saiFile/icons/tv-truchat.png" 
                            alt="app image" 
                            className="p-7"
                            data-tooltip-id="common_tooltip" 
                            data-tooltip-content="TruChat Widget"
                            style={{ cursor: 'pointer' }}
                        />
                        <CommonTooltip
                            id="common_tooltip"
                            style= {{ backgroundColor: "black", color: "white", fontSize:"14px" }}
                            place="top"
                            float={true}
                        />
                    </div>
                    <div className='col-md-3 channel-box me-4'>
                        <img src="/saiFile/icons/tv-whatsapp.png" alt="app image" className="p-7"
                        data-tooltip-id="common_tooltip" 
                        data-tooltip-content="WhatsApp"
                        style={{ cursor: 'pointer' }}/>
                    </div>

                    <div className='col-md-3 channel-box'>
                        <img src="/saiFile/icons/tv-telegram.png" alt="app image" className="p-7" data-tooltip-id="common_tooltip" 
                        data-tooltip-content="Telegram"
                        style={{ cursor: 'pointer' }}/>
                    </div>
                    <div className='col-md-3 channel-box me-4'>
                        <img src="/saiFile/icons/tv-messenger.png" alt="app image" className="p-7" data-tooltip-id="common_tooltip" 
                        data-tooltip-content="Messenger"
                        style={{ cursor: 'pointer' }} />
                    </div>
                    <div className='col-md-3 channel-box me-4'>
                        <img src="/saiFile/icons/speech.png" alt="app image" className="p-7" data-tooltip-id="common_tooltip" 
                        data-tooltip-content="Speech"
                        style={{ cursor: 'pointer' }}/>
                    </div>

                    <div className='col-md-3 channel-box'>
                        <img src="/saiFile/icons/tv-webrtc.png" alt="app image" className="p-7" data-tooltip-id="common_tooltip" 
                        data-tooltip-content="WebRTC"
                        style={{ cursor: 'pointer' }}/>
                    </div>
                    <div className='col-md-3 channel-box me-4'>
                        <img src="/saiFile/icons/tv-sip.png" alt="app image" className="p-7" data-tooltip-id="common_tooltip" 
                        data-tooltip-content="SIP Trunking"
                        style={{ cursor: 'pointer' }} />
                    </div>
                    <div className='col-md-3 channel-box me-4'>
                        <img src="/saiFile/icons/tv-deepgram.png" alt="app image" className="p-7" data-tooltip-id="common_tooltip" 
                        data-tooltip-content="Deepgram"
                        style={{ cursor: 'pointer' }}  />
                    </div>

                    <div className='col-md-3 channel-box'>
                        <img src="/saiFile/icons/tv-amazon-polly.png" alt="app image" className="p-7" data-tooltip-id="common_tooltip" 
                        data-tooltip-content="Amazon Polly"
                        style={{ cursor: 'pointer' }}  />
                    </div>
                </div>
            </div>
        </div>
    )
}

export {PlIntegration}